import { useRef } from 'react'
import { Container } from 'typescript-ioc/es5'
import { useRefEffect } from './use-ref-effect'

export const useService = <T>(svc: new () => T): T => {
    const svcRef = useRef(Container.get(svc))
    return svcRef.current
}
